<template>
  <div class="box" v-if="sweepstakes">
    <div class="box-header">
      <h2 class="box-title">
        {{$t('bounties.sweepstakesOverviewTitle')}}
      </h2>
      <div class="add-on">
        {{ $tc(
          'bounties.sweepstakesOverviewCounter',
          sweepstakes.length,
          { number: sweepstakes.length }
        ) }}
      </div>
    </div>
    <div class="box-body">
      <bounties-overview-container>
        <bounty
          v-for="reward in sweepstakes"
          :key="reward.id"
          :compact="true"
          :bounty="reward"
          :display-icon="false"
          :custom-style="bountyCustomStyle"
        />
        <template v-if="sweepstakes.length < 4">
          <div
            v-for="n in 4 - sweepstakes.length"
            :key="n"
            class="blank-item"
          ></div>
        </template>
      </bounties-overview-container>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Bounty from './Bounty'
import BountiesOverviewContainer from './BountiesOverviewContainer'
import {
  mdiWalletGiftcard,
  mdiTicket,
  mdiCheckCircle,
  mdiCartPlus
} from '@mdi/js'

export default {
  name: "SweepstakesOverview",
  components: {
    Bounty,
    BountiesOverviewContainer
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      sweepstakes: null,
      icons: {
        mdiWalletGiftcard,
        mdiTicket,
        mdiCheckCircle, mdiCartPlus
      },
    }
  },
  computed: {
    bountyCustomStyle() {
      return _.get(this.data, 'style.bounty', null)
    }
  },
  async mounted() {
    await this.$store.dispatch('getRewards', {once: true})
    this.sweepstakes = this.$store.state.sweepstakes
  },
}
</script>

<style scoped lang="scss"></style>
